import { render, staticRenderFns } from "./ClassroomHeader.vue?vue&type=template&id=4812e77e&"
import script from "./ClassroomHeader.vue?vue&type=script&lang=js&"
export * from "./ClassroomHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports